import ReportStatisticCard from "@/admin/insights/member-reports/common/MemberReportStatisticCard"
import { MemberReportTimeSpentOnCurriculumStatisticCardFragment$key } from "@/admin/insights/member-reports/common/__generated__/MemberReportTimeSpentOnCurriculumStatisticCardFragment.graphql"
import { useLabels } from "@/core/context/LabelsContext"
import DateUtils from "@utils/date/dateUtils"
import { graphql, useFragment } from "react-relay"

interface Props {
  organizationMembershipKey: MemberReportTimeSpentOnCurriculumStatisticCardFragment$key
}

export default function MemberReportTimeSpentOnCurriculumStatisticCard({
  organizationMembershipKey,
}: Props) {
  const labels = useLabels()
  const organizationMembership =
    useFragment<MemberReportTimeSpentOnCurriculumStatisticCardFragment$key>(
      graphql`
        fragment MemberReportTimeSpentOnCurriculumStatisticCardFragment on OrganizationMembership
        @argumentDefinitions(startDate: { type: "String" }) {
          timeSpentOnCurriculumSecondsReport(startDate: $startDate) {
            allTime
          }
        }
      `,
      organizationMembershipKey
    )

  return (
    <ReportStatisticCard
      testid={"MemberReportTimeSpentOnCurriculumStatisticCard"}
      value={
        organizationMembership.timeSpentOnCurriculumSecondsReport?.allTime
          ? DateUtils.formatSecondsToHMS(
              organizationMembership.timeSpentOnCurriculumSecondsReport.allTime,
              { spaceOut: true }
            )
          : "-"
      }
      subtitle={`Total Time Spent on ${labels.curriculum.singular}`}
      tooltip={`The total time this ${labels.admin_member.singular} has spent on the ${labels.curriculum.singular} across all ${labels.admin_experience.plural}.`}
    />
  )
}
